import { ROLL_CONVENTION_ENUM } from '../enums/roll-convention.enum';

export const ROLL_CONVENTION = [
  { id: ROLL_CONVENTION_ENUM.PRECEDING, displayValue: 'Preceding' },
  { id: ROLL_CONVENTION_ENUM.FOLLOWING, displayValue: 'Following' },
  {
    id: ROLL_CONVENTION_ENUM.MODIFIED_FOLLOWING,
    displayValue: 'Modified following',
  },
  { id: ROLL_CONVENTION_ENUM.NO_ROLL, displayValue: 'No roll' },
];
